import { money } from '../lib/format';
import { DetailList } from './figures';

export function NoCareOutcome({ deathBenefit }: { deathBenefit: number }) {
  return (
    <div className="flex flex-col gap-3">
      <DetailList
        rows={[
          { label: 'Long-term care payments', value: money(0) },
          { label: 'Death benefit if no care is needed', value: money(deathBenefit) },
        ]}
      />
      <p className="text-muted-foreground text-sm">
        The death benefit goes to your beneficiaries; it isn’t added to your care funding. Check the
        contract’s guarantees, surrender values and charges.
      </p>
      <p className="text-muted-foreground text-sm">
        Personal funds stay yours, subject to spending, investment results and taxes.
      </p>
    </div>
  );
}
